<template>
  <div>
    <a-modal
      centered
      :maskClosable="false"
      title="设置门店角色权限"
      v-model="visible"
      width="70%"
      @ok="handleOk"
      cancelText="关闭"
      :confirmLoading="confirmLoading.handleOkLoading"
    >
      <div style="height: calc(100vh - 350px)">
        <a-layout id="components-layout-demo-side" style="height: 100%">
          <a-layout-sider>
            <a-tree
              style="overflow:auto;height:100%"
              :treeData="treeData"
              @select="onSelect"
              :defaultSelectedKeys="checkedKeys"
            ></a-tree>
          </a-layout-sider>
          <a-layout>
            <div>
              <div style="padding:8px;background: white;">
                <a-button
                  style="margin-left:5px"
                  type="primary"
                  @click="onAddCompanyRole()"
                  >新增</a-button
                >
                <a-button
                  style="margin-left:10px"
                  type="primary"
                  :disabled="disabled"
                  @click="qermission('1')"
                  >菜单权限</a-button
                >
                <a-button
                  style="margin-left:10px"
                  type="primary"
                  :disabled="disabled"
                  @click="roleQermission"
                  >功能权限</a-button
                >
                <a-button
                  style="margin-left:10px"
                  type="primary"
                  :disabled="disabled"
                  @click="roleReportQermission"
                  >报表权限</a-button
                >
              </div>
              <data-grid
                ref="dataGrid"
                :columns="columns"
                v-model="data"
                rowKey="RoleId"
                @selectRow="onSelectRow"
                bordered
              />
            </div>
          </a-layout>
        </a-layout>
      </div>
    </a-modal>

    <!-- 门店角色编辑弹窗 -->
    <a-modal
      centered
      :maskClosable="false"
      :title="title"
      v-model="companyRoleEditModal"
      width="500px"
      @ok="onSubmitCompanyRole"
      :confirmLoading="confirmLoading.submitCompanyRoleLoading"
    >
      <div style="height: 40px;text-align: center;margin-top: 10px;">
        <label>角色名称：</label>
        <a-input style="width:70%;" v-model="roleName"></a-input>
      </div>
      <div style="height: 50px;text-align: center;margin-top: 10px;">
        <label>默认菜单：</label>
        <a-select
          style="width:70%;"
          v-model="defaultMenuId"
          allowClear
          showSearch
          :filterOption="filterOption"
        >
          <a-select-option
            v-for="(item, index) in defaultMenuSelect"
            :key="index"
            :value="item.Id"
            >{{ item.Text }}</a-select-option
          >
        </a-select>
      </div>
    </a-modal>

    <!-- 复制门店角色弹窗 -->
    <a-modal
      centered
      :maskClosable="false"
      title="复制角色到门店"
      v-model="copyCompanyRoleModal"
      width="500px"
      @ok="onSubmitCopyCompanyRole"
      :confirmLoading="confirmLoading.submitCopyCompanyRoleLoading"
    >
      <div style="text-align: center;margin-top: 10px;">
        <label>门店：</label>
        <a-select
          v-model="selectCompanyId"
          mode="multiple"
          style="width: 250px"
          allowClear
          showSearch
          :filterOption="filterOption"
        >
          <a-select-option
            v-for="(item, index) in treeData"
            :key="index"
            :value="item.key"
            :disabled="checkedKeys[0] == item.key"
            >{{ item.title }}
          </a-select-option>
        </a-select>
      </div>
    </a-modal>

    <!--菜单权限 -->
    <checkbox-tree
      title="菜单权限"
      :visible="qermissionOption.qermissionModal"
      :option="qermissionOption"
      type="1"
      @submit="onSubmitQermission"
      @close="onCloseQermission"
    />
  </div>
</template>

<script>
import { DataGrid } from "@/components/dataGrid";
import CheckboxTree from "@/components/dataTree/CheckboxTree";
import { RoleQermissionModal, RoleReportQermissionModal } from "./funtion.js";
export default {
  name: "groupCompanyRoleQermission",
  components: { DataGrid, CheckboxTree },
  props: {
    roleId: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      visible: false,
      disabled: true, //是否禁用门店角色权限设置功能
      confirmLoading: {
        submitCompanyRoleLoading: false,
        submitCopyCompanyRoleLoading: false,
        handleOkLoading: false
      },
      companyRoleEditModal: false,
      recordId: "", //记录当前选择门店的操作角色id
      title: "", //新增 编辑标题
      roleName: "", //新增编辑的门店角色名称
      defaultMenuId: null, //分店默认菜单
      defaultMenuSelect: [], //默认菜单下拉数据
      copyCompanyRoleModal: false,
      selectCompanyId: [], //复制角色时，选择要复制到那个门店
      checkedKeys: [], //当前选择的门店节点
      treeData: [], //左边树数据
      columns: [
        {
          title: "角色名称",
          dataIndex: "RoleName",
          width: "25%"
        },
        {
          title: "默认菜单",
          dataIndex: "DefaultMenu",
          width: "20%"
        },
        {
          title: "受否授权",
          dataIndex: "Checked",
          width: "15%",
          edit: {
            type: "checkbox"
          }
        },
        {
          title: "操作",
          dataIndex: "RoleId",
          width: "40%",
          customRender: (text, record) => {
            if (record.CanEidt) {
              const edit = {
                click: () => {
                  this.onEditCompanyRole(record);
                }
              };
              const copy = {
                click: () => {
                  this.onCopyCompanyRole(record);
                }
              };
              const del = {
                confirm: () => {
                  this.onDelCompanyRole(record.RoleId);
                }
              };
              return (
                <div>
                  <a-button type="link" {...{ on: edit }}>
                    编辑
                  </a-button>{" "}
                  |{" "}
                  <a-button type="link" {...{ on: copy }}>
                    复制
                  </a-button>{" "}
                  |{" "}
                  <a-popconfirm
                    title="你确认删除吗？"
                    {...{ on: { ...del } }}
                    okText="确定"
                    cancelText="取消"
                  >
                    <a-button type="link">删除 </a-button>
                  </a-popconfirm>
                </div>
              );
            }
          }
        }
      ],
      data: [],
      qermissionOption: {
        id: "",
        api: "",
        valueField: "Code",
        textField: "Name",
        children: "Childs",
        parentNode: false,
        qermissionModal: false
      }
    };
  },
  created() {
    this.Init();
  },
  mounted() {
    this.visible = true;
  },
  methods: {
    onCancel() {
      this.$emit("destroy");
    },
    Init() {
      this.$post("GetGroupSelectItems", {
        Types: "company"
      }).then(res => {
        res.Data.company.forEach(item => {
          this.treeData.push({ key: item.Id, title: item.Text });
        });
        this.checkedKeys.push(this.treeData[0].key);
        this.onGetCompanyRoles(this.treeData[0].key); //默认选择第一个节点
      });
      // this.$post("Common_GetSelect", {
      //   types: "menu"
      // }).then(res => {
      //   this.defaultMenuSelect = res.Data.menu;
      // });
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    // 选中节点 刷新右边数据
    onGetCompanyRoles(key) {
      this.$post("GroupRole_GetCompanyRoles", {
        GroupRoleId: this.roleId,
        CompanyId: key
      }).then(res => {
        this.data = res.Data;
      });
    },
    onAddCompanyRole() {
      this.companyRoleEditModal = true;
      this.title = "新增门店角色";
      this.roleName = "";
      this.defaultMenuId = null;
      this.recordId = "";
      this.defaultMenuSelect = [];
    },
    onEditCompanyRole(record) {
      this.companyRoleEditModal = true;
      this.title = "编辑门店角色";
      this.roleName = record.RoleName;

      this.recordId = record.RoleId;
      this.$post("Common_GetRoleMenu", {
        Id: record.RoleId
      }).then(res => {
        this.defaultMenuSelect = res.Data;
        var item = res.Data.find(p => p.Id == record.DefaultMenuId);
        if (item) {
          this.defaultMenuId =
            record.DefaultMenuId == 0 ? null : record.DefaultMenuId;
        } else this.defaultMenuId = null;
      });
    },
    onSubmitCompanyRole() {
      if (this.roleName.trim() == "") {
        this.$message.info("请填写名称！");
        return;
      }
      this.confirmLoading.submitCompanyRoleLoading = true;
      let api = "GroupRole_AddCompanyRole";
      let json = {
        Name: this.roleName,
        DefaultMenuId: this.defaultMenuId,
        CompanyId: this.checkedKeys[0]
      };
      if (this.recordId != "") {
        api = "GroupRole_EditCompanyRole";
        json.Id = this.recordId;
      }
      this.$post(api, json)
        .then(() => {
          this.$message.info("操作成功");
          this.companyRoleEditModal = false;
          this.confirmLoading.submitCompanyRoleLoading = false;
          this.onGetCompanyRoles(this.checkedKeys[0]);
        })
        .catch(() => {
          this.confirmLoading.submitCompanyRoleLoading = false;
        });
    },
    onDelCompanyRole(id) {
      this.$post("GroupRole_DeleteCompanyRole", {
        Id: id
      }).then(() => {
        this.$message.info("删除成功");
        this.onGetCompanyRoles(this.checkedKeys[0]);
      });
    },
    onCopyCompanyRole(record) {
      this.recordId = record.RoleId;
      this.copyCompanyRoleModal = true;
      this.selectCompanyId = [];
    },
    onSubmitCopyCompanyRole() {
      if (!this.selectCompanyId.length) {
        this.$message.info("请选择门店！");
        return;
      }
      this.confirmLoading.submitCopyCompanyRoleLoading = true;
      this.$post("GroupRole_CopyRole", {
        RoleId: this.recordId,
        // TargetCompanyId: this.selectCompanyId,
        TargetCompanyIds: this.selectCompanyId
      })
        .then(() => {
          this.$message.info("复制成功");
          this.copyCompanyRoleModal = false;
          this.confirmLoading.submitCopyCompanyRoleLoading = false;
        })
        .catch(() => {
          this.confirmLoading.submitCopyCompanyRoleLoading = false;
        });
    },
    //选择的树节点
    onSelect(selectedKeys) {
      this.checkedKeys = selectedKeys;
      this.onGetCompanyRoles(selectedKeys[0]);
    },
    onSelectRow(row) {
      if (row && row.CanEidt) {
        this.disabled = false;
      } else {
        this.disabled = true;
      }
    },
    // 菜单权限
    qermission(type) {
      let row = this.$refs.dataGrid.getSelected();
      if (!row) {
        this.$message.info("请先选择一条数据！");
        return false;
      }
      if (type == "1") {
        this.qermissionOption.api = "GroupRole_GetRoleMenus";
      }
      this.qermissionOption.id = row.RoleId;
      this.qermissionOption.qermissionModal = true;
    },
    //菜单权限提交
    onSubmitQermission(type, treeData, checkedKeys) {
      let row = this.$refs.dataGrid.getSelected();
      const json = { RoleId: row.RoleId, MenuCodes: checkedKeys };
      let url = "";
      if (type == "1") url = "GroupRole_SetRoleMenus";

      this.$post(url, json).then(() => {
        this.qermissionOption.qermissionModal = false;
        this.$message.success("操作成功！");
      });
    },
    //菜单权限关闭弹窗
    onCloseQermission() {
      this.qermissionOption.qermissionModal = false;
    },
    //角色权限
    roleQermission() {
      let row = this.$refs.dataGrid.getSelected();
      if (!row) {
        this.$message.info("请先选择一条数据！");
        return false;
      }
      RoleQermissionModal({
        roleId: row.RoleId,
        leftApi: "GroupRole_GetCompanyPermissionModules"
      });
    },
    //角色报表权限
    roleReportQermission() {
      let row = this.$refs.dataGrid.getSelected();
      if (!row) {
        this.$message.info("请先选择一条数据！");
        return false;
      }
      RoleReportQermissionModal({
        roleId: row.RoleId,
        companyId: this.checkedKeys[0]
      });
    },
    //确认
    handleOk() {
      this.confirmLoading.handleOkLoading = true;
      let json = {
        GroupRoleId: this.roleId,
        CompanyId: this.checkedKeys[0],
        CompanyRoleIds: []
      };
      this.data.forEach(item => {
        if (item.Checked) json.CompanyRoleIds.push(item.RoleId);
      });
      this.$post("GroupRole_SetCompanyRoles", json)
        .then(() => {
          this.$message.info("操作成功");
          // this.visible = false;
          this.confirmLoading.handleOkLoading = false;
        })
        .catch(() => {
          this.confirmLoading.handleOkLoading = false;
        });
    }
  },
  // 计算属性
  computed: {},
  watch: {}
};
</script>

<style lang="less" scoped>
.ant-layout-sider {
  -webkit-transition: all 0.2s;
  transition: all 0.2s;
  position: relative;
  background: white;
  min-width: 0;
}
</style>
